import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Notification from './components/Notification'

const EmptyNotificationsWrapper = styled.div`
    margin: 8px;
    text-align: center;
    color: #384047;
    font-weight: bold;
`

class NotificationsTray extends React.Component {
  render () {
    const { notifications } = this.props

    // Handle no notifications case
    if (!notifications || notifications.length === 0) {
      return (
        <EmptyNotificationsWrapper>No notifications available</EmptyNotificationsWrapper>
      )
    }

    // Gather all unread notifications
    const unreadNotifications = notifications.filter((notification) => {
      return !notification.readAt
    })

    // Gather all read notifications
    const readNotifications = notifications.filter((notification) => {
      return notification.readAt
    })

    // Shuffle unread notifications to the top
    return (
      <div>
        {
          unreadNotifications.map((notification, index) => {
            return (
              <Notification notification={notification} key={`NotificationsTray-${index}`} />
            )
          })
        }
        {
          readNotifications.map((notification, index) => {
            return (
              <Notification notification={notification} key={`NotificationsTray-${index}`} />
            )
          })
        }
      </div>
    )
  }
}

NotificationsTray.propTypes = {
  notifications: PropTypes.array.isRequired,
}

export default NotificationsTray



// WEBPACK FOOTER //
// ./src/molecules/NotificationsBell/NotificationsTray.js